/**
 * ============================================================
 *  N8N AI Agent Chat Widget  — Shopify-ready
 *  Version: 1.0.1
 * ============================================================
 *
 *  HOW TO INSTALL ON SHOPIFY
 *  ─────────────────────────
 *  1. In your Shopify Admin go to:
 *     Online Store → Themes → Edit Code
 *  2. Open  layout/theme.liquid
 *  3. Paste ONE of the following just before </body>:
 *
 *     Option A – self-hosted (upload this file to Assets):
 *       <script src="{{ 'chat-widget.js' | asset_url }}" defer></script>
 *
 *     Option B – inline (paste the entire file contents inside a <script> tag):
 *       <script> ...paste file contents here... </script>
 *
 * ============================================================
 *  CONFIGURATION  ← Edit everything in this block
 * ============================================================
 */
(function () {
  "use strict";

  /* ─────────────────────────────────────────────────────────
     CONFIG  — change these values to customise your widget
  ───────────────────────────────────────────────────────── */
  var CONFIG = {

    /* --- ENDPOINT ---------------------------------------- */
    // Your n8n webhook URL.  The widget POSTs JSON to this URL.
    // Expected request  body: { "chatInput": "…", "sessionId": "…" }
    // Expected response body: { "output": "…" }
    //   (n8n's built-in Chat trigger uses exactly this format)
    webhookUrl: "https://connector.omniflow.media/webhook/e1972687-5b91-4758-89e6-c7713aec40f5/chat",

    /* --- IDENTITY --------------------------------------- */
    botName:          "PWD Somellier",
    botAvatar:        "https://cdn.shopify.com/s/files/1/0716/2236/1328/files/pwd-ai-agent-icon.png",          // URL to an image, or "" for initials fallback
    welcomeMessage:   "Hi there! How can I help you today?",
    inputPlaceholder: "Type a message…",

    /* --- COLOURS ---------------------------------------- */
    // Primary accent (header, send button, user bubbles)
    colorPrimary:     "#CEB37E",   // indigo
    // Bot bubble background
    colorBotBubble:   "#F1F5F9",
    // Bot bubble text
    colorBotText:     "#1E293B",
    // User bubble background (defaults to colorPrimary if left "")
    colorUserBubble:  "#3D3834",
    // User bubble text
    colorUserText:    "#FFFFFF",
    // Widget launcher button background (defaults to colorPrimary if "")
    colorLauncher:    "",
    // Optional image/avatar URL for the launcher button (replaces the chat icon)
    launcherImage:    "",
    // Chat window background
    colorBackground:  "#EFECEF",
    // Input bar background
    colorInputBg:     "#f8fafc",
    // Input text colour
    colorInputText:   "#1e293b",
    // Header text colour
    colorHeaderText:  "#FFFFFF",
    // Timestamp / meta text
    colorMeta:        "#94a3b8",

    /* --- LAYOUT ----------------------------------------- */
    // "bottom-right" | "bottom-left"
    position:         "bottom-right",
    // Distance from the edge of the viewport (px)
    offsetX:          24,
    offsetY:          24,
    // Chat window dimensions
    windowWidth:      380,
    windowHeight:     560,
    // Launcher button size (px)
    launcherSize:     56,
    // Border radius of the chat window (px)
    borderRadius:     16,

    /* --- BEHAVIOUR -------------------------------------- */
    // Open the widget automatically after X milliseconds (0 = don't auto-open)
    autoOpenDelay:    7200,
    // Show a greeting bubble next to the launcher after X ms (0 = disable)
    greetingDelay:    3000,
    greetingText:     "👋 Need help? Ask me anything!",
    // How often to show the auto-open / greeting popup:
    //   "always"           — show on every page load (default)
    //   "once-per-session" — show once per browser session (resets when tab/browser closed)
    //   "once-ever"        — show only the very first time a visitor arrives
    greetingFrequency: "once-per-session",
    // How long (ms) to wait for n8n before showing an error
    requestTimeout:   30000,
    // Text shown in the footer bar at the bottom of the chat window
    footerText:       "Powered by Ecom-AI-Agent",
    // Optional URL — makes the footer text a clickable link (empty = plain text)
    footerLink:       "https://fi.ecom-ai-agent.net",
    // Show timestamps on messages
    showTimestamps:   true,
    // Enable sound on new bot message (requires user interaction first)
    enableSound:      true,

    /* --- HISTORY & SESSION ------------------------------ */
    // Save chat history to localStorage so it survives page refreshes
    saveHistory:          true,
    // Max number of messages to keep in storage (oldest are trimmed)
    historyMaxMessages:   200,
    // Keep the same session ID across page loads (required for n8n memory nodes)
    persistSession:       true,

    /* --- HUMAN HANDOFF ---------------------------------- */
    // Set to true to enable the human handoff feature
    handoffEnabled:       true,
    // Base URL of your dashboard handoff API (no trailing slash)
    // e.g. "https://clientarea.omniflow.media/api/handoff"
    handoffUrl:           "https://clientarea.omniflow.media/api/handoff",
    // Message shown to the user when handoff is initiated
    handoffMessage:       "You are now connected to a live agent. They will be with you shortly. ",
    // Message shown when the agent ends the session
    handoffEndMsg:        "The agent has ended the session. You are back with the AI assistant.",

  };
  /* ─────────────────────────────────────────────────────────
     END CONFIG
  ───────────────────────────────────────────────────────── */

  // Allow external override — set window.n8nChatConfig = { ... }
  // BEFORE loading this file to override any CONFIG values.
  // The configurator uses this so you never have to edit the JS.
  if (window.n8nChatConfig) {
    Object.assign(CONFIG, window.n8nChatConfig);
  }

  // ── Resolve colour aliases ────────────────────────────────
  CONFIG.colorUserBubble = CONFIG.colorUserBubble || CONFIG.colorPrimary;
  CONFIG.colorLauncher   = CONFIG.colorLauncher   || CONFIG.colorPrimary;

  // ── Storage keys ─────────────────────────────────────────
  var SESSION_KEY = "n8n_chat_session_id";
  var HISTORY_KEY = "n8n_chat_history";

  // ── Session ID ───────────────────────────────────────────
  // Use localStorage when saveHistory is on (survives refresh); otherwise sessionStorage (tab-only)
  var _store = (function () {
    try {
      var s = CONFIG.saveHistory ? localStorage : sessionStorage;
      s.setItem("__cw_test", "1"); s.removeItem("__cw_test");
      return s;
    } catch (e) { return { getItem: function(){return null;}, setItem: function(){}, removeItem: function(){} }; }
  })();

  var sessionId = (function () {
    if (CONFIG.persistSession) {
      var stored = _store.getItem(SESSION_KEY);
      if (stored) return stored;
    }
    var id = "sess_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    if (CONFIG.persistSession) _store.setItem(SESSION_KEY, id);
    return id;
  })();

  // ── History store ─────────────────────────────────────────
  // Each entry: { role: "bot"|"user"|"error", text: "...", time: "HH:MM" }
  var _history = [];

  function loadHistory() {
    if (!CONFIG.saveHistory) return;
    try {
      var raw = _store.getItem(HISTORY_KEY);
      if (raw) _history = JSON.parse(raw) || [];
    } catch (e) { _history = []; }
  }

  function saveHistory() {
    if (!CONFIG.saveHistory) return;
    try {
      // Trim to max
      if (_history.length > CONFIG.historyMaxMessages) {
        _history = _history.slice(_history.length - CONFIG.historyMaxMessages);
      }
      _store.setItem(HISTORY_KEY, JSON.stringify(_history));
    } catch (e) {}
  }

  function clearHistory() {
    _history = [];
    try { _store.removeItem(HISTORY_KEY); } catch (e) {}
    // Clear the DOM too
    if (messagesEl) {
      messagesEl.innerHTML = "";
      if (CONFIG.welcomeMessage) addMessage(CONFIG.welcomeMessage, "bot", { noSave: true });
    }
  }

  // ── CSS ──────────────────────────────────────────────────
  var styles = "\n\
:root {\n\
  --cw-primary:      " + CONFIG.colorPrimary     + ";\n\
  --cw-bot-bubble:   " + CONFIG.colorBotBubble   + ";\n\
  --cw-bot-text:     " + CONFIG.colorBotText     + ";\n\
  --cw-user-bubble:  " + CONFIG.colorUserBubble  + ";\n\
  --cw-user-text:    " + CONFIG.colorUserText    + ";\n\
  --cw-launcher:     " + CONFIG.colorLauncher    + ";\n\
  --cw-bg:           " + CONFIG.colorBackground  + ";\n\
  --cw-input-bg:     " + CONFIG.colorInputBg     + ";\n\
  --cw-input-text:   " + CONFIG.colorInputText   + ";\n\
  --cw-header-text:  " + CONFIG.colorHeaderText  + ";\n\
  --cw-meta:         " + CONFIG.colorMeta        + ";\n\
  --cw-radius:       " + CONFIG.borderRadius     + "px;\n\
  --cw-w:            " + CONFIG.windowWidth      + "px;\n\
  --cw-h:            " + CONFIG.windowHeight     + "px;\n\
  --cw-launcher-sz:  " + CONFIG.launcherSize     + "px;\n\
}\n\
\n\
#cw-root *, #cw-root *::before, #cw-root *::after { box-sizing: border-box; }\n\
\n\
/* Launcher */\n\
#cw-launcher {\n\
  position: fixed;\n\
  " + (CONFIG.position === "bottom-left" ? "left" : "right") + ": " + CONFIG.offsetX + "px;\n\
  bottom: " + CONFIG.offsetY + "px;\n\
  width: var(--cw-launcher-sz);\n\
  height: var(--cw-launcher-sz);\n\
  border-radius: 50%;\n\
  background: var(--cw-launcher);\n\
  box-shadow: 0 4px 20px rgba(0,0,0,.25);\n\
  cursor: pointer;\n\
  display: flex;\n\
  align-items: center;\n\
  justify-content: center;\n\
  z-index: 999999;\n\
  border: none;\n\
  overflow: hidden;\n\
  transition: transform .2s ease, box-shadow .2s ease;\n\
  outline: none;\n\
}\n\
#cw-launcher:hover  { transform: scale(1.08); box-shadow: 0 6px 28px rgba(0,0,0,.30); }\n\
#cw-launcher:active { transform: scale(.96); }\n\
#cw-launcher svg    { width: 26px; height: 26px; fill: #fff; transition: transform .25s ease; }\n\
#cw-launcher .cw-icon-close { display: none; }\n\
#cw-launcher.cw-open .cw-icon-chat  { display: none; }\n\
#cw-launcher.cw-open .cw-icon-close { display: block; }\n\
#cw-launcher .cw-launcher-img { width: 100%; height: 100%; object-fit: cover; display: block; }\n\
#cw-launcher.cw-open .cw-launcher-img { display: none; }\n\
\n\
/* Greeting bubble */\n\
#cw-greeting {\n\
  position: fixed;\n\
  " + (CONFIG.position === "bottom-left" ? "left" : "right") + ": " + CONFIG.offsetX + "px;\n\
  bottom: " + (CONFIG.offsetY + CONFIG.launcherSize + 16) + "px;\n\
  background: #fff;\n\
  color: #1e293b;\n\
  padding: 16px 18px;\n\
  border-radius: 16px;\n\
  font-size: 14px;\n\
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n\
  box-shadow: 0 6px 24px rgba(0,0,0,.14), 0 2px 8px rgba(0,0,0,.08);\n\
  z-index: 999998;\n\
  max-width: 300px;\n\
  min-width: 200px;\n\
  line-height: 1.45;\n\
  opacity: 0;\n\
  transform: translateY(10px);\n\
  transition: opacity .3s ease, transform .3s ease;\n\
  pointer-events: none;\n\
  white-space: normal;\n\
  display: flex;\n\
  align-items: center;\n\
  gap: 12px;\n\
}\n\
#cw-greeting::after {\n\
  content: '';\n\
  position: absolute;\n\
  bottom: -8px;\n\
  " + (CONFIG.position === "bottom-left" ? "left: 20px" : "right: 20px") + ";\n\
  border: 8px solid transparent;\n\
  border-top-color: #fff;\n\
  border-bottom: 0;\n\
}\n\
#cw-greeting.cw-visible { opacity: 1; transform: translateY(0); pointer-events: auto; }\n\
#cw-greeting .cw-greeting-close {\n\
  position: absolute; top: 8px; right: 10px;\n\
  cursor: pointer; font-size: 14px; color: #94a3b8; background: none; border: none; line-height: 1;\n\
  padding: 2px; transition: color .15s ease;\n\
}\n\
#cw-greeting .cw-greeting-close:hover { color: #475569; }\n\
.cw-greeting-avatar {\n\
  width: 48px; height: 48px; border-radius: 50%; flex-shrink: 0;\n\
  background: var(--cw-bot-bubble); display: flex; align-items: center;\n\
  justify-content: center; overflow: hidden;\n\
}\n\
.cw-greeting-avatar img { width: 100%; height: 100%; object-fit: cover; }\n\
.cw-greeting-text { flex: 1; padding-right: 14px; }\n\
\n\
/* Window */\n\
#cw-window {\n\
  position: fixed;\n\
  " + (CONFIG.position === "bottom-left" ? "left" : "right") + ": " + CONFIG.offsetX + "px;\n\
  bottom: " + (CONFIG.offsetY + CONFIG.launcherSize + 12) + "px;\n\
  width: var(--cw-w);\n\
  height: var(--cw-h);\n\
  max-width: calc(100vw - " + (CONFIG.offsetX * 2) + "px);\n\
  max-height: calc(100vh - " + (CONFIG.offsetY + CONFIG.launcherSize + 24) + "px);\n\
  background: var(--cw-bg);\n\
  border-radius: var(--cw-radius);\n\
  box-shadow: 0 8px 40px rgba(0,0,0,.18);\n\
  display: flex;\n\
  flex-direction: column;\n\
  overflow: hidden;\n\
  z-index: 999998;\n\
  opacity: 0;\n\
  transform: translateY(16px) scale(.97);\n\
  transition: opacity .25s ease, transform .25s ease;\n\
  pointer-events: none;\n\
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n\
  font-size: 14px;\n\
}\n\
#cw-window.cw-open {\n\
  opacity: 1;\n\
  transform: translateY(0) scale(1);\n\
  pointer-events: auto;\n\
}\n\
\n\
/* Header */\n\
#cw-header {\n\
  background: var(--cw-primary);\n\
  color: var(--cw-header-text);\n\
  padding: 14px 16px;\n\
  display: flex;\n\
  align-items: center;\n\
  gap: 10px;\n\
  flex-shrink: 0;\n\
}\n\
#cw-header-avatar {\n\
  width: 36px; height: 36px;\n\
  border-radius: 50%;\n\
  background: rgba(255,255,255,.25);\n\
  display: flex; align-items: center; justify-content: center;\n\
  font-size: 15px; font-weight: 700;\n\
  overflow: hidden; flex-shrink: 0;\n\
}\n\
#cw-header-avatar img { width: 100%; height: 100%; object-fit: cover; }\n\
#cw-header-info { flex: 1; min-width: 0; }\n\
#cw-header-name {\n\
  font-weight: 600; font-size: 15px; line-height: 1.2;\n\
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n\
}\n\
#cw-header-status { font-size: 12px; opacity: .85; }\n\
.cw-status-dot {\n\
  display: inline-block;\n\
  width: 7px; height: 7px; border-radius: 50%;\n\
  background: #4ade80; margin-right: 4px;\n\
  vertical-align: middle;\n\
}\n\
#cw-header-close {\n\
  background: none; border: none; cursor: pointer;\n\
  color: var(--cw-header-text); opacity: .8;\n\
  padding: 4px; border-radius: 6px;\n\
  display: flex; align-items: center;\n\
  transition: opacity .15s;\n\
  flex-shrink: 0;\n\
}\n\
#cw-header-close:hover { opacity: 1; }\n\
\n\
/* Messages */\n\
#cw-messages {\n\
  flex: 1;\n\
  overflow-y: auto;\n\
  padding: 16px 16px;\n\
  display: flex;\n\
  flex-direction: column;\n\
  gap: 12px;\n\
  scroll-behavior: smooth;\n\
}\n\
#cw-messages::-webkit-scrollbar { width: 4px; }\n\
#cw-messages::-webkit-scrollbar-track { background: transparent; }\n\
#cw-messages::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }\n\
\n\
.cw-msg-row {\n\
  display: flex;\n\
  align-items: flex-end;\n\
  gap: 8px;\n\
  max-width: 100%;\n\
}\n\
.cw-msg-row.cw-user { flex-direction: row-reverse; }\n\
.cw-msg-row.cw-bot  { padding-left: 4px; }\n\
\n\
.cw-msg-avatar {\n\
  width: 28px; height: 28px; border-radius: 50%;\n\
  background: var(--cw-bot-bubble);\n\
  display: flex; align-items: center; justify-content: center;\n\
  font-size: 12px; font-weight: 700; flex-shrink: 0;\n\
  overflow: hidden; align-self: flex-end;\n\
}\n\
.cw-msg-avatar img { width: 100%; height: 100%; object-fit: cover; }\n\
\n\
.cw-msg-col { display: flex; flex-direction: column; gap: 3px; max-width: 72%; }\n\
.cw-user .cw-msg-col { align-items: flex-end; }\n\
\n\
/* ── Message bubbles ─────────────────────────────────────────\n\
   Bot  → display:block  (fills column, left-aligned text)\n\
   User → display:inline-block (shrinks to text width)\n\
   Padding (12px 15px) comfortably exceeds nothing — we rely on\n\
   NOT having overflow:hidden so the border-radius is purely\n\
   decorative and never clips any text.\n\
─────────────────────────────────────────────────────────── */\n\
.cw-bubble {\n\
  padding: 11px 18px;\n\
  border-radius: 18px;\n\
  line-height: 1.55;\n\
  overflow-wrap: break-word;\n\
  word-break: break-word;\n\
  max-width: 100%;\n\
}\n\
.cw-bot  .cw-bubble {\n\
  background: var(--cw-bot-bubble);\n\
  color: var(--cw-bot-text);\n\
  border-bottom-left-radius: 5px;\n\
  white-space: normal;\n\
  display: block;\n\
}\n\
.cw-user .cw-bubble {\n\
  background: var(--cw-user-bubble);\n\
  color: var(--cw-user-text);\n\
  border-bottom-right-radius: 5px;\n\
  white-space: pre-wrap;\n\
  display: inline-block;\n\
}\n\
\n\
/* ── Reset default margins on HTML elements inside bubbles ── */\n\
.cw-bubble p, .cw-bubble ul, .cw-bubble ol, .cw-bubble blockquote,\n\
.cw-bubble h1, .cw-bubble h2, .cw-bubble h3, .cw-bubble h4, .cw-bubble h5, .cw-bubble h6,\n\
.cw-bubble pre, .cw-bubble figure { margin: 0; padding: 0; }\n\
\n\
/* ── Markdown rendered content inside bot bubbles ── */\n\
.cw-bubble img {\n\
  display: block;\n\
  max-width: 100%;\n\
  max-height: 280px;\n\
  object-fit: contain;\n\
  border-radius: 8px;\n\
  margin: 6px auto 2px;\n\
  cursor: zoom-in;\n\
  border: 1px solid rgba(0,0,0,.08);\n\
  background: #f8fafc;\n\
}\n\
.cw-bubble img:first-child { margin-top: 2px; }\n\
.cw-bubble a {\n\
  color: var(--cw-primary);\n\
  text-decoration: underline;\n\
  overflow-wrap: break-word;\n\
  word-break: break-word;\n\
}\n\
.cw-bubble a:hover { opacity: .8; }\n\
.cw-bubble strong { font-weight: 700; }\n\
.cw-bubble em { font-style: italic; }\n\
.cw-bubble code {\n\
  background: rgba(0,0,0,.07);\n\
  border-radius: 4px;\n\
  padding: 1px 5px;\n\
  font-family: 'SFMono-Regular', Consolas, monospace;\n\
  font-size: 13px;\n\
}\n\
/* Image lightbox overlay */\n\
#cw-lightbox {\n\
  display: none;\n\
  position: fixed;\n\
  inset: 0;\n\
  background: rgba(0,0,0,.82);\n\
  z-index: 9999999;\n\
  align-items: center;\n\
  justify-content: center;\n\
  cursor: zoom-out;\n\
}\n\
#cw-lightbox.cw-open { display: flex; }\n\
#cw-lightbox img {\n\
  max-width: 90vw;\n\
  max-height: 88vh;\n\
  border-radius: 10px;\n\
  object-fit: contain;\n\
  box-shadow: 0 8px 40px rgba(0,0,0,.5);\n\
}\n\
#cw-lightbox-close {\n\
  position: absolute; top: 16px; right: 20px;\n\
  color: #fff; font-size: 28px; cursor: pointer;\n\
  background: none; border: none; line-height: 1;\n\
  opacity: .8;\n\
}\n\
#cw-lightbox-close:hover { opacity: 1; }\n\
\n\
.cw-ts {\n\
  font-size: 11px; color: var(--cw-meta);\n\
  padding: 0 3px;\n\
}\n\
\n\
/* Typing indicator */\n\
.cw-typing .cw-bubble {\n\
  background: var(--cw-bot-bubble);\n\
  padding: 12px 16px;\n\
}\n\
.cw-dots { display: flex; gap: 5px; align-items: center; }\n\
.cw-dots span {\n\
  width: 7px; height: 7px; border-radius: 50%;\n\
  background: #94a3b8;\n\
  animation: cw-bounce .9s infinite ease-in-out;\n\
}\n\
.cw-dots span:nth-child(2) { animation-delay: .15s; }\n\
.cw-dots span:nth-child(3) { animation-delay: .30s; }\n\
@keyframes cw-bounce {\n\
  0%, 60%, 100% { transform: translateY(0);    opacity: .5; }\n\
  30%            { transform: translateY(-5px); opacity: 1; }\n\
}\n\
\n\
/* Error message */\n\
.cw-error .cw-bubble {\n\
  background: #fee2e2;\n\
  color: #dc2626;\n\
  font-size: 13px;\n\
}\n\
\n\
/* Input bar */\n\
#cw-input-bar {\n\
  display: flex;\n\
  align-items: center;\n\
  gap: 8px;\n\
  padding: 10px 12px;\n\
  border-top: 1px solid #e2e8f0;\n\
  background: var(--cw-input-bg);\n\
  flex-shrink: 0;\n\
  pointer-events: auto !important;\n\
}\n\
#cw-input {\n\
  flex: 1;\n\
  border: 1px solid #e2e8f0;\n\
  border-radius: 24px;\n\
  padding: 9px 14px;\n\
  font-size: 14px;\n\
  font-family: inherit;\n\
  color: var(--cw-input-text);\n\
  background: #fff;\n\
  outline: none;\n\
  resize: none;\n\
  line-height: 1.4;\n\
  max-height: 100px;\n\
  overflow-y: auto;\n\
  transition: border-color .15s;\n\
  touch-action: manipulation !important;\n\
  -webkit-user-select: text !important;\n\
  user-select: text !important;\n\
  pointer-events: auto !important;\n\
  cursor: text !important;\n\
}\n\
#cw-input:focus { border-color: var(--cw-primary); }\n\
#cw-send {\n\
  width: 38px; height: 38px; border-radius: 50%;\n\
  background: var(--cw-primary);\n\
  border: none; cursor: pointer;\n\
  display: flex; align-items: center; justify-content: center;\n\
  flex-shrink: 0;\n\
  transition: opacity .15s, transform .15s;\n\
  pointer-events: auto !important;\n\
  -webkit-appearance: none;\n\
  appearance: none;\n\
  touch-action: manipulation;\n\
  cursor: pointer !important;\n\
}\n\
#cw-send:hover:not(:disabled)  { opacity: .88; }\n\
#cw-send:active:not(:disabled) { transform: scale(.93); }\n\
#cw-send:disabled { opacity: .45; cursor: not-allowed !important; }\n\
#cw-send svg { width: 18px; height: 18px; fill: #fff; pointer-events: none; }\n\
\n\
/* Footer */\n\
#cw-footer {\n\
  text-align: center;\n\
  font-size: 11px;\n\
  color: var(--cw-meta);\n\
  padding: 5px 0 8px;\n\
  background: var(--cw-input-bg);\n\
  flex-shrink: 0;\n\
}\n\
#cw-footer a {\n\
  color: var(--cw-meta); text-decoration: none;\n\
  transition: color .15s ease;\n\
}\n\
#cw-footer a:hover { color: var(--cw-primary); text-decoration: underline; }\n\
\n\
/* Mobile */\n\
@media (max-width: 480px) {\n\
  #cw-window {\n\
    " + (CONFIG.position === "bottom-left" ? "left" : "right") + ": 0 !important;\n\
    bottom: 0 !important;\n\
    width: 100vw !important;\n\
    max-width: 100vw !important;\n\
    height: 100dvh !important;\n\
    max-height: 100dvh !important;\n\
    border-radius: 0 !important;\n\
  }\n\
  #cw-launcher.cw-open { display: none !important; }\n\
}\n\
\n\
/* Live Agent handoff indicator */\n\
#cw-live-badge {\n\
  display: inline-flex;\n\
  align-items: center;\n\
  gap: 5px;\n\
  font-size: 11px;\n\
  font-weight: 600;\n\
  color: #fff;\n\
  background: rgba(0,0,0,.22);\n\
  border-radius: 20px;\n\
  padding: 2px 8px;\n\
  margin-left: 8px;\n\
  vertical-align: middle;\n\
  letter-spacing: .02em;\n\
}\n\
#cw-live-badge::before {\n\
  content: '';\n\
  width: 7px;\n\
  height: 7px;\n\
  border-radius: 50%;\n\
  background: #4ade80;\n\
  flex-shrink: 0;\n\
  animation: cw-pulse 1.4s infinite ease-in-out;\n\
}\n\
@keyframes cw-pulse {\n\
  0%, 100% { opacity: 1; transform: scale(1); }\n\
  50%       { opacity: .5; transform: scale(.8); }\n\
}\n\
";

  // ── Inject CSS ───────────────────────────────────────────
  var styleEl = document.createElement("style");
  styleEl.textContent = styles;
  document.head.appendChild(styleEl);

  // ── SVG icons ────────────────────────────────────────────
  var ICON_CHAT  = '<svg viewBox="0 0 24 24" class="cw-icon-chat"  xmlns="http://www.w3.org/2000/svg"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" class="cw-icon-close" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';
  var ICON_SEND  = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>';
  var ICON_X     = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:14px;height:14px;fill:currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';

  // ── Build initials avatar ────────────────────────────────
  function initials(name) {
    return (name || "A").split(" ").map(function (w) { return w[0]; }).slice(0, 2).join("").toUpperCase();
  }

  function avatarHTML(size) {
    if (CONFIG.botAvatar) return '<img src="' + CONFIG.botAvatar + '" alt="">';
    return '<span style="font-size:' + Math.floor(size * .4) + 'px;color:var(--cw-primary)">' + initials(CONFIG.botName) + '</span>';
  }

  // ── Safe markdown → DOM renderer ─────────────────────────
  // Uses createTextNode / createElement so no XSS is possible.
  // Supported: ![alt](url)  [text](url)  bare https://...  **bold**  __bold__
  //            *italic*  _italic_  `code`  \n→<br>
  // Only http/https URLs are allowed for images and links.
  function renderMarkdown(text, container) {
    // Normalise: strip zero-width chars that break regex matching
    var clean = text.replace(/[\u200B\u200C\u200D\uFEFF]/g, "");

    // Combined tokeniser regex — order matters
    // Groups: 1=img-alt 2=img-url 3=link-text 4=link-url 5=bare-url
    //         6=**bold** 7=__bold__ 8=*italic* 9=_italic_ 10=`code`
    var TOKEN = /!\[([^\]]*)\]\s*\((https?:\/\/[^\s)]+)\)|\[([^\]]*)\]\s*\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s<>"'\]]+)|\*\*([^*\n]+)\*\*|__([^_\n]+)__|\*([^*\n]+)\*|(?<!\w)_([^_\n]+)_(?!\w)|`([^`\n]+)`|\n/g;
    var lastIndex = 0;
    var match;

    while ((match = TOKEN.exec(clean)) !== null) {
      // Plain text chunk before this token
      if (match.index > lastIndex) {
        container.appendChild(document.createTextNode(clean.slice(lastIndex, match.index)));
      }

      var full = match[0];

      if (full.charAt(0) === "!" && full.charAt(1) === "[") {
        // ── Image ──────────────────────────────────────────
        var img = document.createElement("img");
        img.src = match[2];
        img.alt = match[1] || "image";
        img.title = match[1] || "";
        img.onerror = function () { this.style.display = "none"; };
        img.addEventListener("click", openLightbox);
        container.appendChild(img);

      } else if (full.charAt(0) === "[") {
        // ── Markdown link [text](url) ──────────────────────
        var a = document.createElement("a");
        a.href = match[4];
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.textContent = match[3] || match[4];
        container.appendChild(a);

      } else if (match[5]) {
        // ── Bare URL https://... ───────────────────────────
        var url = match[5].replace(/[.,!?:;)'"]+$/, "");
        var ab = document.createElement("a");
        ab.href = url;
        ab.target = "_blank";
        ab.rel = "noopener noreferrer";
        ab.textContent = url;
        container.appendChild(ab);
        if (url.length < match[5].length) {
          container.appendChild(document.createTextNode(match[5].slice(url.length)));
        }

      } else if (match[6] || match[7]) {
        // ── Bold (**text** or __text__) ──────────────────────
        var strong = document.createElement("strong");
        renderMarkdown(match[6] || match[7], strong);
        container.appendChild(strong);

      } else if (match[8] || match[9]) {
        // ── Italic (*text* or _text_) ────────────────────────
        var em = document.createElement("em");
        renderMarkdown(match[8] || match[9], em);
        container.appendChild(em);

      } else if (match[10]) {
        // ── Inline code ────────────────────────────────────
        var code = document.createElement("code");
        code.textContent = match[10];
        container.appendChild(code);

      } else if (full === "\n") {
        // ── Line break ─────────────────────────────────────
        container.appendChild(document.createElement("br"));
      }

      lastIndex = TOKEN.lastIndex;
    }

    // Any remaining plain text
    if (lastIndex < clean.length) {
      container.appendChild(document.createTextNode(clean.slice(lastIndex)));
    }
  }

  // ── Lightbox for image zoom ───────────────────────────────
  var lightbox, lightboxImg;
  function buildLightbox() {
    lightbox = document.createElement("div");
    lightbox.id = "cw-lightbox";
    lightbox.innerHTML = '<button id="cw-lightbox-close" aria-label="Close image">&times;</button><img alt="enlarged image">';
    lightboxImg = lightbox.querySelector("img");
    lightbox.addEventListener("click", closeLightbox);
    lightbox.querySelector("#cw-lightbox-close").addEventListener("click", closeLightbox);
    document.body.appendChild(lightbox);
  }
  function openLightbox(e) {
    e.stopPropagation();
    lightboxImg.src = this.src;
    lightbox.classList.add("cw-open");
  }
  function closeLightbox() {
    lightbox.classList.remove("cw-open");
  }

  // ── Create DOM ───────────────────────────────────────────
  var root = document.createElement("div");
  root.id = "cw-root";

  var launcher = document.createElement("button");
  launcher.id = "cw-launcher";
  launcher.setAttribute("aria-label", "Open chat");
  launcher.innerHTML = (CONFIG.launcherImage
    ? '<img class="cw-launcher-img" src="' + CONFIG.launcherImage + '" alt="">'
    : ICON_CHAT) + ICON_CLOSE;

  var greeting = document.createElement("div");
  greeting.id = "cw-greeting";
  greeting.innerHTML = '<button class="cw-greeting-close" aria-label="Dismiss">' + ICON_X + '</button>' +
    '<div class="cw-greeting-avatar">' + avatarHTML(48) + '</div>' +
    '<div class="cw-greeting-text">' + CONFIG.greetingText + '</div>';

  var win = document.createElement("div");
  win.id = "cw-window";
  win.setAttribute("role", "dialog");
  win.setAttribute("aria-label", CONFIG.botName + " chat");
  win.innerHTML = '\
<div id="cw-header">\
  <div id="cw-header-avatar">' + avatarHTML(36) + '</div>\
  <div id="cw-header-info">\
    <div id="cw-header-name">' + CONFIG.botName + '</div>\
    <div id="cw-header-status"><span class="cw-status-dot"></span>Online</div>\
  </div>\
  <button id="cw-header-close" aria-label="Close chat">' + ICON_X + '</button>\
</div>\
<div id="cw-messages" role="log" aria-live="polite" aria-label="Chat messages"></div>\
<div id="cw-input-bar">\
  <textarea id="cw-input" rows="1" placeholder="' + CONFIG.inputPlaceholder + '" aria-label="Message input"></textarea>\
  <button id="cw-send" aria-label="Send message">' + ICON_SEND + '</button>\
</div>\
<div id="cw-footer"></div>\
';

  root.appendChild(launcher);
  root.appendChild(greeting);
  root.appendChild(win);
  document.body.appendChild(root);
  // Set footer text from config (with optional link)
  var footerEl = document.getElementById("cw-footer");
  if (CONFIG.footerLink) {
    var a = document.createElement("a");
    a.href = CONFIG.footerLink;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.textContent = CONFIG.footerText;
    footerEl.appendChild(a);
  } else {
    footerEl.textContent = CONFIG.footerText;
  }
  buildLightbox();

  // ── Element refs ─────────────────────────────────────────
  var messagesEl = document.getElementById("cw-messages");
  var inputEl    = document.getElementById("cw-input");
  var sendBtn    = document.getElementById("cw-send");

  // ── State ────────────────────────────────────────────────
  var isOpen      = false;
  var isWaiting   = false;
  var isHandoff   = false;
  var _sseSource  = null;

  // ── Helpers ──────────────────────────────────────────────
  function timestamp() {
    var d = new Date();
    return d.getHours().toString().padStart(2, "0") + ":" + d.getMinutes().toString().padStart(2, "0");
  }

  function scrollToBottom() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ── Render one message into the DOM ──────────────────────
  // opts.noSave = true  → don't push to _history (used when replaying saved history)
  // opts.time           → timestamp string to display
  function addMessage(text, role, opts) {
    opts = opts || {};
    var isBot = role === "bot";
    var isErr = role === "error";
    var ts    = opts.time || timestamp();

    // Save to history (unless told not to)
    if (!opts.noSave) {
      _history.push({ role: role, text: text, time: ts });
      saveHistory();
    }

    var row = document.createElement("div");
    row.className = "cw-msg-row " + (isBot || isErr ? "cw-bot" : "cw-user") + (isErr ? " cw-error" : "");

    var col = document.createElement("div");
    col.className = "cw-msg-col";

    var bubble = document.createElement("div");
    bubble.className = "cw-bubble";

    if (isBot || isErr) {
      // Bot messages: render markdown (safe DOM-based renderer)
      renderMarkdown(text, bubble);
    } else {
      // User messages: plain text only
      bubble.textContent = text;
    }

    col.appendChild(bubble);

    if (CONFIG.showTimestamps) {
      var tsEl = document.createElement("div");
      tsEl.className = "cw-ts";
      tsEl.textContent = ts;
      col.appendChild(tsEl);
    }

    if (isBot || isErr) {
      var av = document.createElement("div");
      av.className = "cw-msg-avatar";
      av.innerHTML = avatarHTML(28);
      row.appendChild(av);
    }

    row.appendChild(col);
    messagesEl.appendChild(row);
    scrollToBottom();
    return row;
  }

  // ── Restore history from localStorage ────────────────────
  function restoreHistory() {
    loadHistory();
    if (_history.length === 0) return false;
    for (var i = 0; i < _history.length; i++) {
      var m = _history[i];
      addMessage(m.text, m.role, { noSave: true, time: m.time });
    }
    return true;
  }

  // ── Typing indicator ─────────────────────────────────────
  function showTyping() {
    var row = document.createElement("div");
    row.className = "cw-msg-row cw-bot cw-typing";
    row.id = "cw-typing-row";
    var av = document.createElement("div");
    av.className = "cw-msg-avatar";
    av.innerHTML = avatarHTML(28);
    var col = document.createElement("div");
    col.className = "cw-msg-col";
    var bubble = document.createElement("div");
    bubble.className = "cw-bubble";
    bubble.innerHTML = '<div class="cw-dots"><span></span><span></span><span></span></div>';
    col.appendChild(bubble);
    row.appendChild(av);
    row.appendChild(col);
    messagesEl.appendChild(row);
    scrollToBottom();
  }

  function removeTyping() {
    var r = document.getElementById("cw-typing-row");
    if (r) r.remove();
  }

  // ── Open / close ─────────────────────────────────────────
  function openWidget() {
    isOpen = true;
    win.classList.add("cw-open");
    launcher.classList.add("cw-open");
    launcher.setAttribute("aria-label", "Close chat");
    greeting.classList.remove("cw-visible");
    setTimeout(function () { inputEl.focus(); }, 280);
  }

  function closeWidget() {
    isOpen = false;
    win.classList.remove("cw-open");
    launcher.classList.remove("cw-open");
    launcher.setAttribute("aria-label", "Open chat");
  }

  function toggleWidget() { isOpen ? closeWidget() : openWidget(); }

  // ── Send message ─────────────────────────────────────────
  function sendMessage() {
    var text = inputEl.value.trim();
    if (!text || isWaiting) return;

    addMessage(text, "user");
    inputEl.value = "";
    autoResizeInput();

    isWaiting = true;
    sendBtn.disabled = true;
    showTyping();

    var timedOut = false;
    var timer = setTimeout(function () {
      timedOut = true;
      removeTyping();
      addMessage("It seems your request was too broad — could you try to narrow it down a little?", "error");
      isWaiting = false;
      sendBtn.disabled = false;
    }, CONFIG.requestTimeout);

    // During handoff: send message directly to dashboard, not n8n
    var fetchUrl = (isHandoff && CONFIG.handoffEnabled && CONFIG.handoffUrl)
      ? CONFIG.handoffUrl + "/message"
      : CONFIG.webhookUrl;

    fetch(fetchUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ chatInput: text, sessionId: sessionId })
    })
      .then(function (res) {
        if (!res.ok) throw new Error("HTTP " + res.status);
        return res.json();
      })
      .then(function (data) {
        clearTimeout(timer);
        if (timedOut) return;
        removeTyping();

        // Log the raw n8n response so we can debug handoff detection
        console.log("[ChatWidget] n8n response received:", JSON.stringify(data));
        console.log("[ChatWidget] handoff check — data.handoff:", data.handoff, "| handoffEnabled:", CONFIG.handoffEnabled, "| handoffUrl:", CONFIG.handoffUrl);

        // Check for human handoff signal from n8n
        if (data.handoff === true && CONFIG.handoffEnabled && CONFIG.handoffUrl) {
          // Show the holding message from n8n if provided, then open SSE
          var raw = data.output || data.text || data.message || "";
          if (raw) addMessage(raw, "bot");
          initiateHandoff();
          isWaiting = false;
          sendBtn.disabled = false;
          return;
        }

        // During handoff the dashboard handles replies via SSE — no message to display here
        if (isHandoff) {
          isWaiting = false;
          sendBtn.disabled = false;
          return;
        }

        // n8n returns { output: "..." } — fall back to common alternatives
        var raw = data.output || data.text || data.message || data.response
          || (Array.isArray(data) && data[0] && (data[0].output || data[0].text || data[0].message))
          || "";
        // Ensure reply is always a string (output could be object/array in some n8n configs)
        var reply = typeof raw === "string" ? raw
          : (raw && typeof raw === "object" && (raw.text || raw.message || raw.output || raw.response))
          || (Array.isArray(raw) ? raw.join("\n") : String(raw || ""))
          || "I didn't get a response. Please try again.";
        addMessage(reply, "bot");
        isWaiting = false;
        sendBtn.disabled = false;

        // Polling fallback — if n8n didn't include handoff:true but the dashboard
        // has already marked this session as active, detect it here.
        if (CONFIG.handoffEnabled && CONFIG.handoffUrl && !isHandoff) {
          pollForHandoff(4, 2500);
        }

        if (CONFIG.enableSound) {
          try {
            var ctx  = new (window.AudioContext || window.webkitAudioContext)();
            var osc  = ctx.createOscillator();
            var gain = ctx.createGain();
            osc.connect(gain); gain.connect(ctx.destination);
            osc.frequency.value = 880;
            gain.gain.setValueAtTime(.08, ctx.currentTime);
            gain.gain.exponentialRampToValueAtTime(.0001, ctx.currentTime + .2);
            osc.start(); osc.stop(ctx.currentTime + .2);
          } catch (e) {}
        }
      })
      .catch(function (err) {
        clearTimeout(timer);
        removeTyping();
        addMessage("Something went wrong. Please check your connection and try again.", "error");
        console.error("[ChatWidget] Request failed:", err);
        isWaiting = false;
        sendBtn.disabled = false;
      });
  }

  // ── Auto-resize textarea ─────────────────────────────────
  function autoResizeInput() {
    inputEl.style.height = "auto";
    inputEl.style.height = Math.min(inputEl.scrollHeight, 100) + "px";
  }

  // ── Human handoff ────────────────────────────────────────
  function showHandoffIndicator() {
    var nameEl = document.getElementById("cw-header-name");
    if (!nameEl || document.getElementById("cw-live-badge")) return;
    var badge = document.createElement("span");
    badge.id = "cw-live-badge";
    badge.textContent = "Live Agent";
    nameEl.appendChild(badge);
  }

  function removeHandoffIndicator() {
    var badge = document.getElementById("cw-live-badge");
    if (badge) badge.remove();
  }

  function pollForHandoff(attemptsLeft, interval) {
    if (isHandoff || attemptsLeft <= 0 || !CONFIG.handoffEnabled || !CONFIG.handoffUrl) return;
    var statusUrl = CONFIG.handoffUrl + "/status?sessionId=" + sessionId;
    console.log("[ChatWidget] Polling handoff status:", statusUrl, "(attempts left:", attemptsLeft, ")");
    fetch(statusUrl)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (isHandoff) return; // already triggered
        if (d && d.status === "active") {
          console.log("[ChatWidget] Handoff active detected via poll — initiating SSE");
          initiateHandoff();
        } else if (attemptsLeft > 1) {
          setTimeout(function () { pollForHandoff(attemptsLeft - 1, interval); }, interval);
        }
      })
      .catch(function () {
        if (attemptsLeft > 1) {
          setTimeout(function () { pollForHandoff(attemptsLeft - 1, interval); }, interval);
        }
      });
  }

  // Dedup tracker — stores hash of last few SSE messages with timestamps
  // Prevents showing the same message twice if SSE reconnects or server double-sends
  var _sseSeenMessages = [];
  function _sseIsDuplicate(text) {
    var now = Date.now();
    // Expire entries older than 3 seconds
    _sseSeenMessages = _sseSeenMessages.filter(function(m) { return now - m.t < 3000; });
    for (var i = 0; i < _sseSeenMessages.length; i++) {
      if (_sseSeenMessages[i].text === text) return true;
    }
    _sseSeenMessages.push({ text: text, t: now });
    return false;
  }

  function initiateHandoff() {
    // Guard against double-call: bail if already in handoff or SSE already open
    if (!CONFIG.handoffEnabled || !CONFIG.handoffUrl || isHandoff || _sseSource) return;
    isHandoff = true;
    showHandoffIndicator();
    addMessage(CONFIG.handoffMessage, "bot");

    var sseUrl = CONFIG.handoffUrl + "/stream?sessionId=" + sessionId;
    console.log("[ChatWidget] Opening SSE stream:", sseUrl);
    _sseSource = new EventSource(sseUrl);

    // Handle any SSE event — deduplicated to prevent double-display on reconnect
    function handleSSEData(e) {
      console.log("[ChatWidget] SSE event received — type:", e.type, "data:", e.data);
      try {
        var payload = JSON.parse(e.data);
        // Accept text / message / content / reply as the message field
        var text = payload.text || payload.message || payload.content || payload.reply || "";
        if (text && !_sseIsDuplicate(text)) addMessage(text, "bot");
      } catch (err) {
        // If data is plain text (not JSON), display it directly
        if (e.data && e.data.trim() && e.data !== "[DONE]" && !_sseIsDuplicate(e.data)) {
          addMessage(e.data, "bot");
        }
      }
    }

    // onmessage handles unnamed events AND events explicitly typed "message"
    // Do NOT also addEventListener("message") — that causes double-firing
    _sseSource.onmessage = handleSSEData;

    // Named event types dashboards may use (excluding "message" — covered by onmessage above)
    ["reply", "agent_message", "chat", "response"].forEach(function(evtName) {
      _sseSource.addEventListener(evtName, handleSSEData);
    });

    _sseSource.addEventListener("handoff_ended", function (e) {
      console.log("[ChatWidget] SSE handoff_ended received", e.data);
      // Use the message from the event payload if provided, otherwise fall back to config
      var customMsg = "";
      try {
        var payload = JSON.parse(e.data);
        customMsg = payload.message || payload.text || "";
      } catch (err) {}
      endHandoff(customMsg || CONFIG.handoffEndMsg);
    });

    _sseSource.onopen = function () {
      console.log("[ChatWidget] SSE stream connected successfully");
    };

    _sseSource.onerror = function (e) {
      console.warn("[ChatWidget] SSE error/disconnect:", e);
    };
  }

  function endHandoff(msg) {
    isHandoff = false;
    if (_sseSource) { _sseSource.close(); _sseSource = null; }
    removeHandoffIndicator();
    addMessage(msg || CONFIG.handoffEndMsg, "bot");
  }

  // ── Event listeners ──────────────────────────────────────
  launcher.addEventListener("click", toggleWidget);
  // Also handle mousedown so theme JS can't swallow the click
  launcher.addEventListener("mousedown", function (e) { e.preventDefault(); });

  document.getElementById("cw-header-close").addEventListener("click", closeWidget);

  // Send button — listen to both click and mousedown as fallback
  // (some WP themes intercept click events; mousedown fires first)
  var _sendPending = false;
  sendBtn.addEventListener("mousedown", function (e) {
    e.preventDefault(); // prevent focus loss from textarea
    _sendPending = true;
  });
  sendBtn.addEventListener("click", function () {
    _sendPending = false;
    sendMessage();
  });
  sendBtn.addEventListener("mouseup", function () {
    if (_sendPending) { _sendPending = false; sendMessage(); }
  });
  // Touch fallback
  sendBtn.addEventListener("touchend", function (e) {
    e.preventDefault();
    sendMessage();
  });

  inputEl.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  });
  // Also handle keypress for older WP themes that suppress keydown
  inputEl.addEventListener("keypress", function (e) {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  });
  inputEl.addEventListener("input", autoResizeInput);

  greeting.querySelector(".cw-greeting-close").addEventListener("click", function (e) {
    e.stopPropagation();
    greeting.classList.remove("cw-visible");
  });
  greeting.addEventListener("click", function (e) {
    if (!e.target.closest(".cw-greeting-close")) openWidget();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isOpen) closeWidget();
  });

  // ── Initialise ───────────────────────────────────────────
  var hadHistory = restoreHistory();

  // Only show welcome message if there is no saved history to restore
  if (!hadHistory && CONFIG.welcomeMessage) {
    addMessage(CONFIG.welcomeMessage, "bot");
  }

  var isMobile = window.innerWidth <= 480;

  // ── Popup frequency (auto-open + greeting bubble) ────────
  var POPUP_SEEN_KEY = "cw_popup_seen";
  function _popupStore() {
    if (CONFIG.greetingFrequency === "once-per-session") return sessionStorage;
    if (CONFIG.greetingFrequency === "once-ever")        return localStorage;
    return null; // "always" — no storage needed
  }
  function hasSeenPopup() {
    var s = _popupStore();
    if (!s) return false;
    try { return !!s.getItem(POPUP_SEEN_KEY); } catch(e) { return false; }
  }
  function markPopupSeen() {
    var s = _popupStore();
    if (!s) return;
    try { s.setItem(POPUP_SEEN_KEY, "1"); } catch(e) {}
  }

  if (!hasSeenPopup() && !isMobile) {
    if (CONFIG.autoOpenDelay > 0) {
      setTimeout(function () { openWidget(); markPopupSeen(); }, CONFIG.autoOpenDelay);
    }
    if (CONFIG.greetingDelay > 0 && CONFIG.greetingText) {
      setTimeout(function () {
        if (!isOpen) { greeting.classList.add("cw-visible"); markPopupSeen(); }
      }, CONFIG.greetingDelay);
    }
  }

  // ── Public API ────────────────────────────────────────────
  window.ChatWidget = {
    open:    openWidget,
    close:   closeWidget,
    toggle:  toggleWidget,
    // Wipe stored history and reset the chat window
    clearHistory: clearHistory,
    // Update config at runtime, e.g. ChatWidget.setConfig({ webhookUrl: "https://connector.omniflow.media/webhook/14b85f28-c854-45fd-bc2b-fc2782b6985b/chat" })
    setConfig: function (overrides) { Object.assign(CONFIG, overrides); }
  };

})();
